import { Typography } from '@/components/Typography'
import { useState } from 'react'

export const StickySwitchTabs = ({ tabs, selectedTab }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.tabLabel)

  return (
    <div className="flex justify-center">
      <div className="flex bg-[#EFF5FF] p-[4px] gap-[10px] rounded-[10px]">
        {tabs.map((tab, id) => {
          const isActive = activeTab === tab.tabLabel

          return (
            <button
              key={tab.tabLabel}
              onClick={() => {
                setActiveTab(tab.tabLabel)
                selectedTab(id)
              }}
              className={[
                'px-[8px] py-[6px] rounded-[10px] transition-colors border border-transparent',
                isActive ? 'bg-white font-bold!' : 'bg-transparent',
              ].join(' ')}
            >
              <Typography
                className={[
                  'text-nowrap text-sm! text-[#42546B]',
                  isActive ? 'font-bold! ' : '',
                ].join(' ')}
                content={tab.tabLabel}
              />
            </button>
          )
        })}
      </div>
    </div>
  )
}
